module.exports = __webpack_public_path__ + "static/media/badge9.90226fe8.svg";